import { FinancingUser } from '@indigo-ag/schema';
import { getConfigValue } from '@indigo-ag/ui-core';

import i18next from 'core/i18n';
import { Scope } from 'shared';
import { text } from '../text.util';

const systemUserId = getConfigValue('IA_FINANCING_ADMIN_UI_SYSTEM_USER');

export class UserUtil {
  static getUserScope(user: FinancingUser): Scope | undefined {
    const scopePermission = user.permissions.find(perm => (Object.values(Scope) as string[]).includes(perm)) as
      | Scope
      | undefined;

    return scopePermission;
  }

  static getUserFullName(user?: FinancingUser): string {
    if (!user) {
      return '';
    }

    if (user.id === 'UNKNOWN_USER') {
      return text.toTitleCase(i18next.t('unknownUser'));
    }

    if (user.id === systemUserId) {
      return text.toTitleCase(i18next.t('systemUser'));
    }

    return `${text.toTitleCase(user?.firstName || '')} ${user?.lastName}`;
  }
}
